module.exports = __webpack_public_path__ + "static/media/Icon_zoomIn.3b371f16.svg";